import React from 'react';

const Callandbookpopup = () => {
  return (
    <div className="p-6 text-gray-800">
      <div className="text-4xl mb-4 text-[#3D6643]">📞</div>
      <h2 className="text-2xl font-bold text-[#3D6643] mb-4">Direct Call & Book</h2>
      <p className="text-sm mb-4">
        Offer your guests a simple and convenient way to book their stay by enabling direct calling.
      </p>

      <ul className="list-disc list-inside text-sm mb-4 space-y-2">
        <li><strong>Call-Based Bookings:</strong> Guests can quickly inquire about availability and pricing over the phone.</li>
        <li><strong>Personalized Support:</strong> Provide real-time assistance, answer questions, and guide them through the booking process.</li>
        <li><strong>Faster Conversions:</strong> Reduce the steps to booking and convert interest into confirmed reservations instantly.</li>
        <li><strong>Custom Contact Info:</strong> Configure individual contact numbers for each villa or location.</li>
        <li><strong>24/7 Flexibility:</strong> Allow guests to reach out during flexible hours for better engagement.</li>
      </ul>

      <p className="text-sm">
        Direct calling makes booking easier for guests who prefer a human touch and helps you close reservations faster.
      </p>
    </div>
  );
};

export default Callandbookpopup;
